import script from "./CarteleraSubastas.vue?vue&type=script&setup=true&lang=js"
export * from "./CarteleraSubastas.vue?vue&type=script&setup=true&lang=js"

import "./CarteleraSubastas.vue?vue&type=style&index=0&id=09183a24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09183a24"]])

export default __exports__